"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DATA_OVERFLOWING: function() {
        return DATA_OVERFLOWING;
    },
    DATA_OVERFLOW_ITEM: function() {
        return DATA_OVERFLOW_ITEM;
    },
    DATA_OVERFLOW_MENU: function() {
        return DATA_OVERFLOW_MENU;
    },
    DATA_OVERFLOW_DIVIDER: function() {
        return DATA_OVERFLOW_DIVIDER;
    }
});
const DATA_OVERFLOWING = 'data-overflowing';
const DATA_OVERFLOW_ITEM = 'data-overflow-item';
const DATA_OVERFLOW_MENU = 'data-overflow-menu';
const DATA_OVERFLOW_DIVIDER = 'data-overflow-divider';
